<template>
  <section id="news_main_arae" class="section_padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <h2 class="text-coral" style="text-align: left">
            {{ $t('news_area.title') }}
          </h2>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-12 col-12">
          <div class="news_item_boxed">
            <div class="icon-container">
              <i class="icon fas fa-atlas"></i>
            </div>
            <div class="news_item_content">
              <h3>{{ $t('news_area.cards.visibility.title') }}</h3>
              <p>{{ $t('news_area.cards.visibility.body') }}</p>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12 col-12">
          <div class="news_item_boxed">
            <div class="icon-container">
              <i class="icon fas fa-hotel"></i>
            </div>
            <div class="news_item_content">
              <h3>{{ $t('news_area.cards.bookings.title') }}</h3>
              <p>{{ $t('news_area.cards.bookings.body') }}</p>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12 col-12">
          <div class="news_item_boxed text-center">
            <div class="icon-container">
              <i class="icon fas fa-laptop"></i>
            </div>
            <div class="news_item_content">
              <h3>{{ $t('news_area.cards.trust.title') }}</h3>
              <p>{{ $t('news_area.cards.trust.body') }}</p>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12 col-12">
          <div class="news_item_boxed">
            <div class="icon-container">
              <i class="icon fas fa-chart-line"></i>
            </div>
            <div class="news_item_content">
              <h3>{{ $t('news_area.cards.tech.title') }}</h3>
              <p>{{ $t('news_area.cards.tech.body') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "NewsArea",
};
</script>

<style scoped>
.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  background-color: #ff6056;
  border-radius: 50%;
}

.icon {
  font-size: 24px;
  color: white;
}
</style>
